import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'

export const onboardStore = defineStore('onboard', {
  state: () => ({
    lookups: {},
    token: '01E0765A-BC62-44F2-9486-AF7AAC9D723E',
    onboard: {
      basic: null,
      additional: null,
      shipping: null,
      purchase: null
    },
    testMode: false,
    loading: {
      lookups: false,
      onboard: false,
      saving: false
    },
    products: [
      { id: 0, name: 'Annual', value: 'annual' },
      { id: 1, name: 'Monthly', value: 'monthly' },
      { id: 2, name: 'Annual w/Auto-Fill', value: 'annual_autofill' },
      { id: 3, name: 'Monthly w/Auto-Fill', value: 'monthly_autofill' }
    ],
    disable: false,
    purchaseResult: null
  }),
  actions: {
    setTestMode(mode) {
      this.testMode = mode
    },
    setOnboard(data) {
      if (this.onboard === undefined || this.onboard === null) {
        this.onboard = {
          basic: null,
          additional: null,
          shipping: null,
          purchase: null
        }
      }
      if (data !== null) {
        switch (data.type) {
          case 'basic':
            this.onboard.basic = JSON.parse(JSON.stringify(data))
            break
          case 'additional':
            this.onboard.additional = JSON.parse(JSON.stringify(data))
            break
          case 'shipping':
            this.onboard.shipping = JSON.parse(JSON.stringify(data))
            this.onboard.shipping.firm = this.onboard.additional.firm
            break
          case 'purchase':
            this.onboard.purchase = JSON.parse(JSON.stringify(data))
            this.onboard.purchase.firm = this.onboard.additional.firm
            break
          case 'product':
            this.onboard.purchase.product = data.product
            break
        }
      }
    },
    resetPaymentMethod() {
      this.onboard.purchase.paymentMethod = null
    },
    toggleDisable(value) {
      this.disable = value
    },
    prepOnboard() {
      this.onboard = {
        basic: null,
        additional: null,
        shipping: null,
        purchase: null
      }
    },
    async getLookups(data) {
      const store = authStore()
      let _lookups = {}
      let _keys = data.keys.filter((k) => !this.lookups[k])
      let reset = false
      if (data.refresh) {
        reset = data.refresh
      }
      if (_keys.length || reset) {
        this.loading.lookups = true
        let results = await api.post(`onboard/byKeys`, {
          app: data.app ? data.app : null,
          keys: data.keys,
          firm: data.firm ? parseInt(data.firm) : parseInt(store.profile.firm),
          showInactive: false
        })
        this.loading.lookups = false
        if (results) {
          for (let key of data.keys) {
            _lookups[key] = []
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value || item.name
                item.value = item.id || item.value
                item.isInactive = false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(Object.assign(this.lookups, _lookups)))
        }
      }
      console.log('Got Lookups', this.lookups)
      return this.lookups
    },
    async getCountryCode(id) {
      let code = null
      console.log('Getting Country Code', id)
      let found = this.lookups['Country'].find((element) => parseInt(element.value) === parseInt(id))
      if (found) {
        code = found.code
      }
      console.log('Got Country Code', code)
      return code
    },
    async getStateProvinceAbbr(id) {
      let abbr = null
      console.log('Getting State/Province Abbr', id)
      let found = this.lookups['StateProvince'].find((element) => parseInt(element.value) === parseInt(id))
      if (found) {
        abbr = found.name
      }
      console.log('Got State/Province Abbr', abbr)
      return abbr
    },
    async getOnboard(firm) {
      this.loading.onboard = true
      this.onboard = {
        basic: null,
        additional: null,
        shipping: null,
        purchase: null
      }
      let response = await api.get(`onboard/onboardGet?firm=${firm}`)
      if (response) {
        if (response !== '') {
          this.onboard = response
        }
      }
      this.loading.onboard = false
      return this.onboard
    },
    async changeProduct(product) {
      return api.post('onboard/onboardChangeProduct', product)
    },
    async saveOnboard(action) {
      let result = null
      let endpoint = null
      let firm = null
      this.loading.saving = true
      switch (action) {
        case 'basic': {
          console.log('Saving Basic', {
            mode: this.testMode,
            basic: this.onboard.basic
          })
          endpoint = 'onboard/onboardMarketing'
          let data = {
            marketing: this.onboard.basic.marketing,
            firstName: this.onboard.basic.firstname,
            lastName: this.onboard.basic.lastname,
            emailAddress: this.onboard.basic.email,
            token: this.token
          }
          result = await api.post(endpoint, data)
          this.onboard.basic.marketing = result
          break
        }
        case 'additional': {
          console.log('Saving Additional', {
            mode: this.testMode,
            additional: this.onboard.additional
          })
          if (this.onboard.additional.firm !== null) {
            endpoint = 'onboard/onboardFirmUpdate'
          } else {
            endpoint = 'onboard/onboardFirm'
          }
          let data = {
            firm: this.onboard.additional.firm,
            company: this.onboard.additional.company,
            firmName: this.onboard.additional.company,
            firstName: this.onboard.basic.firstname,
            lastName: this.onboard.basic.lastname,
            email: this.onboard.basic.email,
            addressLines: this.onboard.additional.addressLines,
            city: this.onboard.additional.city,
            stateProvince: this.onboard.additional.stateprovince,
            postalCode: this.onboard.additional.postalcode,
            country: this.onboard.additional.country,
            phoneCC: null,
            phoneNo: this.onboard.basic.phone,
            languageId: this.onboard.additional.language,
            timezoneId: this.onboard.additional.timezone,
            webaddress: this.onboard.additional.webaddress,
            firmType: 7, // Shop
            companyId: 1, // Invoices AI
            token: this.token
          }
          result = await api.post(endpoint, data)
          firm = result
          if (firm === '') {
            firm = null
          }
          this.onboard.additional.firm = firm
          break
        }
        case 'purchase': {
          console.log('Saving Purchase', {
            mode: this.testMode,
            basic: this.onboard.purchase
          })
          let country = await this.getCountryCode(this.onboard.additional.country)
          let stateprovince = await this.getStateProvinceAbbr(this.onboard.additional.stateprovince)
          console.log('State/Province/Country', {
            country: country,
            stateprovince: stateprovince
          })
          // Update Purchase Info
          endpoint = 'onboard/onboardPurchaseSave'
          let data = {
            firm: this.onboard.purchase.firm,
            product: this.onboard.purchase.product,
            paymentMethod: {
              id: this.onboard.purchase.paymentMethod.id,
              brand: this.onboard.purchase.paymentMethod.card.brand,
              last4: this.onboard.purchase.paymentMethod.card.last4
            },
            company: this.onboard.additional.company,
            name: `${this.onboard.basic.firstname} ${this.onboard.basic.lastname}`,
            email: this.onboard.basic.email,
            address: {
              addresslines: this.onboard.additional.addressLines,
              city: this.onboard.additional.city,
              stateprovince: stateprovince,
              postalcode: this.onboard.additional.postalcode,
              country: country
            },
            phone: this.onboard.basic.phone,
            coupon: this.onboard.purchase.coupon,
            token: this.token,
            testMode: this.testMode
          }
          result = await api.post(endpoint, data)
          firm = this.onboard.additional.firm
          this.purchaseResult = result
          break
        }
      }
      this.loading.saving = false
      if (result !== null) {
        return { firm: firm, id: result }
      } else {
        return { firm: firm, id: null }
      }
    },
    async cancelSubscription(data) {
      return await api.post('onboard/cancelSubscription', data)
    },
    async changeSubscription(data) {
      return await api.post('onboard/changeSubscription', data)
    }
  }
})
